import React, { useState } from 'react';
import { Image } from 'antd';
import useIsMobile from '@/hooks/useIsMobile';
import ImagePickerContext from '../ImagePickerContext';
import ImagesModal from '../ImagesModal';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const ImagePicker = ({ value, onChange, acceptedFormats = ['image/jpeg', 'image/png', 'image/webp'], maxFileSize = 10485760 }) => {
    const isMobile = useIsMobile(992);
    const [folder, setFolder] = useState('root');
    const viewModel = useComponent({ value, onChange, acceptedFormats, maxFileSize });

    return (
        <ImagePickerContext.Provider
            value={{
                value: [],
                maxPhotos: 1,
                acceptedFormats,
                maxFileSize,
                onChange: viewModel.handleLibrarySelect,
                folder,
                setFolder,
            }}
        >
            {isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />}

            {viewModel.previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: viewModel.previewOpen,
                        onVisibleChange: viewModel.setPreviewOpen,
                        afterOpenChange: (v) => !v && viewModel.setPreviewImage(''),
                    }}
                    src={viewModel.previewImage}
                />
            )}

            <ImagesModal
                open={viewModel.libraryOpen}
                onOk={() => viewModel.setLibraryOpen(false)}
                onCancel={() => viewModel.setLibraryOpen(false)}
            />
        </ImagePickerContext.Provider>
    );
};

export default ImagePicker;

